export default class Enum {
  
  constructor( api, type ) {
    this.api = api
    this.type = type
    this.connect = api.child( 'enum' ).child( type )
  }

  /**
   * Gets the Enum
   **/
  get( data ) {
    return this.connect.get( data )
  }

  /**
   * Updates the Enum header
   */
  update( data ) {
    return this.connect.patchRaw( data )
  }

  /**
   * Removes the Enum
   */
  remove( ) {
    return this.connect.delete( )
  }

  /**
   * List all enum values
   **/ 
  values( opts ) {
    return this.connect.child( 'value' ).get( opts )
  }

  /**
   * add enum value
   **/ 
  addValue( value, data = {} ) {
    return this.connect.child( 'value' ).child( value ).post( data )
  }

  /**
   * update enum value
   **/ 
  updateValue( value, data = {} ) {
    return this.connect.child( 'value' ).child( value ).patchRaw( data )
  }

  /**
   * remove enum value
   **/ 
  removeValue( value ) {
    return this.connect.child( 'value' ).child( value ).delete( )
  }

  /**
   * returns one enum value
   **/ 
  getValue( value, opts ) {
    return this.connect.child( 'value' ).child( value ).get( opts )
  }
}
